export function formatHttpError(response) {
  if (!response) return "An error occurred";
  if (response.body) {
    if (typeof response.body === "string" && response.body)
      return response.body;
    if (response.body.error) return response.body.error;
    if (response.body.message) return response.body.message;
  }
  if (response.bodyText) return `${response.status} ${response.bodyText}`;
  if (response.status)
    return `${response.status} ${response.statusText || "Error"}`;
  return "An error occurred";
}
